import React from 'react';
import { Transition } from 'react-transition-group';

// Import components
import Hamburger from 'components/layout/mobile_nav/hamburger/Hamburger';
import {
	NavDropdown as MainNavDropdown,
	LanguageDropdown
} from 'components/elements';
import NavDropdown from 'components/layout/nav/nav_toolbar/NavDropdown';
import NavSearch from '../nav/nav_search/NavSearch';

// Import styles
import { Wrapper, MenusContainer } from './styles';

// Import utilities
import useMenuToggle from 'components/layout/mobile_nav/hooks/useMenuToggle';

// Import helpers
import { filterOperatorLinks } from 'helpers/operators';
import { NAV_LINKS } from 'components/routes/navlinks';

// Import helpers
import { hasSeveralLanguages } from 'helpers/languages';

const MobileNav = () => {
	const { isOpen, toggle } = useMenuToggle();
	const filteredLinks = NAV_LINKS.filter(filterOperatorLinks);

	return (
		<>
			<Wrapper>
				{hasSeveralLanguages && <LanguageDropdown />}
				<NavDropdown isMobile toggle={toggle} isOpen={isOpen} />
				<Hamburger isOpen={isOpen} toggle={toggle} />
			</Wrapper>

			<Transition
				in={isOpen}
				timeout={{ enter: 0, exit: 500 }}
				mountOnEnter
				unmountOnExit
			>
				{(state) => (
					<MenusContainer className={state}>
						<NavSearch isMobile toggle={toggle} />
						<MainNavDropdown isMainNav links={filteredLinks} isMobile />
					</MenusContainer>
				)}
			</Transition>
		</>
	);
};

export default MobileNav;
